import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Row, Col, Table, Tabs, Spin, Tag, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllAds } from "../../../slices/ads/thunk";
import usecustomStyles from "../../../Common/customStyles";
import DateService from "../../../Services/DateService";
import "./adsSinglePage.scss";
import {
  getAdById,
  getSingleAdAnalytics,
} from "../../../slices/adsAnalytics/thunk";
import { fetchData } from "../../../Services/FetchData";
import { API_ENDPOINTS } from "../../../constants/apiEndPoints";
import Log from "../../../Services/Log";
import {
  getStatus,
  singlePageStatusUpdate,
} from "../../../Services/AdsStatusService";
import { toast } from "react-toastify";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import RejectedUi from "../RejectedUi/RejectedUi";
import { setDuplicateAdThunk } from "../../../slices/DuplicateAd/reducer";
import { Popup_Toast } from "../../../constants/Popups_Toast";
import TableShimmer from "../../../Common/TableShimmer/TableShimmer";
import { resetSingleAd } from "../../../slices/adsAnalytics/reducer";

const AdsSinglePage = ({ activeAddId }) => {
  const isUnmounted = useRef(false);
  let popupContent = Popup_Toast;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const customStyles = usecustomStyles();
  const [adId, setAdId] = useState();
  const [bannerImage, setBannerImage] = useState();
  const [data, setData] = useState(false);
  const [activeAd, setActiveAd] = useState(null);
  const [limit, setLimit] = useState(2);
  const [fetchedUserData, setFetchedUserData] = useState();
  const allAds = useSelector((state) => state.AllAds);
  const [tabType, setTabType] = useState("click");
  const [accessedElement, setAccessedElement] = useState();
  const [currentIsRedeemed, setCurrentIsRedeemed] = useState(false);
  const [limitModal, setLimitModal] = useState(false);
  const [analytics, setAnalytics] = useState();
  const [totalCount, setTotalCount] = useState();
  const [warning, setWarning] = useState({
    title: "",
    content: "",
    verifiedStatus: false,
  });
  const initialValues = {
    vendor_id: "",
    ad_id: "",
    user_id: "",
    type: "",
    message: "",
    location: "",
    user_data: {
      _id: "",
      age: null,
      city: {
        label: "",
        code: "",
      },
      gender: {
        label: "",
        code: "",
      },
      name: "",
      state: {
        label: "",
        code: "",
      },
    },
  };
  const [count, setCount] = useState({
    'clicks': '',
    'views ': '',
    'enquiry': '',
    'accessContact': ''
  })
  const [leadPopup, setLeadPopup] = useState(false);
  const [leadData, setLeadData] = useState({
    'name': '',
    // 'views': '',
    // 'clicks': '',
    'number': '',
    'location': '',
    'accessedDate': ''
  })
  const fetchLeadsData = (response) => {
    setLeadData({
      name: response?.name,
      number: response?.country_code + response?.phone,
      accessedDate: response?.created_at,
      location: response?.city?.city?.label || response?.city?.district,
    })
  }
  const getUserData = async () => {
    if (activeAd?.numberOfLeadsUsed < activeAd?.numberOfLeadsLeft) {
      try {
        setLoading(true);
        const endPoint = API_ENDPOINTS.USER.DATA;
        const response = await fetchData(endPoint, accessUserContact);
        setFetchedUserData(response?.phone);
        fetchLeadsData(response);
        setLeadPopup(true)
        dispatch(getAdById(activeAddId));
        toast.success(popupContent?.CONTACT_ACCESS?.SUCCESSFULLY?.content, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
          className: "custom_toast",
        });
      } catch (error) {
        setLoading(false);
        console.error("Error in getUserData:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLimitModal(true);
    }
  };
  const viewContact = async () => {
    try {
      setLoading(true);
      const endPoint = API_ENDPOINTS.VIEW.DATA;
      const response = await fetchData(endPoint, accessUserContact);
      fetchLeadsData(response);
      setLeadPopup(true)
      setFetchedUserData(response?.phone);
      dispatch(getAdById(activeAddId));
    } catch (error) {
      setLoading(false);
      console.error("Error in getUserData:", error);
    } finally {
      setLoading(false);
    }
  };
  // infinite scroll
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const loadingLimit = 10;

  // const loadingContent = isLoading ? (
  //     <div className="spinner sm inner">
  //         <Spin />
  //     </div>
  // ) : null;

  const [accessUserContact, setAccessUserContact] = useState(initialValues);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    if (activeAddId) {
      dispatch(getAdById(activeAddId));
      let analytics = activeAddId?.analytics;
    }
  }, [activeAddId, dispatch]);

  let singleAdAnalytics = useSelector((state) => state.AdAnalytics?.singleAd);
  const analyticsData = useSelector((state) => state.AdAnalytics.analyticsData);

  useEffect(() => {
    setAnalytics(analyticsData?.data);
    setTotalCount(analyticsData?.count);

    // Cleanup to clear the data when leaving the page
    // return () => {
    //     setAnalytics([]);
    //     setTotalCount(0);  // Optional: Reset total count if needed
    // };
  }, [analyticsData]);

  let flag = 0;
  useEffect(() => {
    if (singleAdAnalytics) {
      let data = singleAdAnalytics[0];
      if (data?.warning) {
        setWarning({
          title: data?.warning?.title,
          content: data?.warning?.description,
          verifiedStatus: data?.status,
          statusClass: singlePageStatusUpdate(data?.status),
        });
      }
      const ad = singleAdAnalytics[0];
      setActiveAd(ad);
      setBannerImage(ad?.ad_images[0]?.original);
      setData(true);
      if (activeAd) {
        if (flag == 0) {
          setLoading(true);
          dispatch(
            getSingleAdAnalytics({
              type: tabType,
              adId: activeAd?.ad_id,
              limit: 10,
              page: 1,
            })
          )
            .then(() => {
              setLoading(false);
            })
            .catch(() => {
              setLoading(false);
            });
          flag++;
        }

        const analytics = activeAd?.analytics || [];

        const updatedCounts = analytics.reduce((acc, el) => {
          acc[el.event] = el.count; // Store event and count as key-value pairs
          return acc;
        }, {});
        setCount(updatedCounts);
      }
    }
  }, [allAds, activeAd, singleAdAnalytics]);

  useEffect(() => {
    return () => {
      setBannerImage("");
    };
  }, [setBannerImage]);

  const handleDuplicate = () => {
    dispatch(setDuplicateAdThunk());
    navigate("/live-ads/new-ads", {
      state: { adItem: activeAd, duplicate: true },
    });
  };

  const pagination = {
    pageSize: 6, // Set the number of items per page
  };
  useEffect(() => {
    setLoading(true);
    dispatch(
      getSingleAdAnalytics({
        type: tabType,
        adId: activeAd?.ad_id,
        limit: 10,
        page: 1,
      })
    )
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    setAccessedElement();
  }, [tabType]);
  const viewsColumns = [
    {
      title: "State",
      key: "state",
      render: (record) => (
        <span className="md">{record.userData?.state?.label}</span>
      ),
    },
    {
      title: "City",
      key: "city",
      render: (record) => (
        <span className="md">{record.userData?.city?.label}</span>
      ),
    },
    {
      title: "Gender",
      key: "gender",
      render: (record) => (
        <span className="md">{record.userData?.gender?.label}</span>
      ),
    },
    {
      title: "Age",
      key: "age",
      render: (record) => <span className="md">{record.userData?.age}</span>,
    },
    {
      title: "Total Count",
      key: "view_count",
      render: (record) => <span className="md">{record.view_count}</span>,
    },
    {
      title: "Contact Details",
      key: "is_redeemed",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div
              className={`data_wrap ${record.is_redeemed ? "not_active" : "active"
                }`}
            >
              <span>
                {record.is_redeemed
                  ? "View "
                  : "Access"}
              </span>
              {/* temporary */}
              {/* <span>{record?.vendor_id}</span> */}
              {/* {record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )} */}
            </div>
          </Button>
        </span>
      ),
    },
  ];
  const contactAccessedColumn = [
    {
      title: "Date & Time",
      key: "state",
      render: (record) => (
        <Link to="#!" className="md">
          {DateService.formatDateCustom(record?.created_at, true)}
        </Link>
      ),
    },
    {
      title: "Name",
      key: "city",
      render: (record) => {
        return (
          <span className="md">
            {record?.name ? record?.name : record?.userData?.name}
          </span>
        );
      },
    },
    {
      title: "Location",
      key: "gender",
      render: (record) => {
        return <span className="md">{record.userData?.city?.label}</span>;
      },
    },
    {
      title: "Contact Details",
      key: "is_redeemed",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div
              className={`data_wrap ${record.is_redeemed ? "not_active" : "active"
                }`}
            >
              <span>
                {record.is_redeemed
                  ? "View "
                  : "Access"}
              </span>
              {/* temporary */}
              {/* <span>{record?.vendor_id}</span> */}
              {record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )}
            </div>
          </Button>
        </span>
      ),
    },
  ];
  const enquiryColumns = [
    {
      title: "Date & Time",
      key: "date",
      render: (record) => (
        <Link to="#!" className="md">
          {DateService.formatDateCustom(record?.created_at, true)}
        </Link>
      ),
    },
    {
      title: "State",
      key: "state",
      render: (record) => (
        <span className="md">{record.userData?.state?.label}</span>
      ),
    },
    {
      title: "Place",
      key: "place",
      render: (record) => (
        <span className="md">{record.userData?.city?.label}</span>
      ),
    },
    {
      title: "Name",
      key: "city",
      render: (record) => {
        return (
          <span className="md">
            {record?.name ? record?.name : record?.userData?.name}
          </span>
        );
      },
    },
    {
      title: "Message",
      width: "20%",
      key: "gender",
      className: "lg_width",
      render: (record) => {
        return <span className="md">{record?.message}</span>;
      },
    },
    {
      title: "Contact Details",
      key: "is_redeemed",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div
              className={`data_wrap ${record.is_redeemed ? "not_active" : "active"
                }`}
            >
              <span>
                {record.is_redeemed
                  ? "View "
                  : "Access"}
              </span>
              {/* temporary */}
              {/* <span>{record?.vendor_id}</span> */}
              {record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )}
            </div>
          </Button>
        </span>
      ),
    },
  ];

  const tabsHandle = (key) => {
    console.log('key', key)
    setTabType(key);
    setAnalytics();
    setLoading(true);
  };
  const formattedStartDate = activeAd?.start_date
    ? DateService.formatDateCustom(activeAd.start_date)
    : null;
  const formattedEndDate = activeAd?.end_date
    ? DateService.formatDateCustom(activeAd.end_date)
    : null;



  const dataFetching = (data) => {
    setFetchedUserData();
    setCurrentIsRedeemed(data?.is_redeemed);
    setAccessedElement(data?._id);
    let isDataComplete =
      data?.vendor_id &&
      activeAd?.ad_id &&
      data?.user_id &&
      tabType &&
      data?.userData?._id &&
      data?.userData?.age &&
      data?.userData?.city?.label &&
      data?.userData?.city?.code &&
      data?.userData?.gender?.label &&
      data?.userData?.gender?.code &&
      data?.userData?.name &&
      data?.userData?.state?.label &&
      data?.userData?.state?.code;

    // let isDataComplete = true;

    // if (!data?.vendor_id) {
    //     console.log('Missing vendor_id');
    //     isDataComplete = false;
    // }

    // if (!activeAd?.ad_id) {
    //     console.log('Missing ad_id');
    //     isDataComplete = false;
    // }

    // if (!data?.user_id) {
    //     console.log('Missing user_id');
    //     isDataComplete = false;
    // }

    // if (!tabType) {
    //     console.log('Missing tabType');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?._id) {
    //     console.log('Missing userData._id');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.age) {
    //     console.log('Missing userData.age');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.city?.label) {
    //     console.log('Missing userData.city.label');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.city?.code) {
    //     console.log('Missing userData.city.code');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.gender?.label) {
    //     console.log('Missing userData.gender.label');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.gender?.code) {
    //     console.log('Missing userData.gender.code');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.name) {
    //     console.log('Missing userData.name');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.state?.label) {
    //     console.log('Missing userData.state.label');
    //     isDataComplete = false;
    // }

    // if (!data?.userData?.state?.code) {
    //     console.log('Missing userData.state.code');
    //     isDataComplete = false;
    // }

    if (isDataComplete) {
      setAccessUserContact((prev) => {
        return {
          ...prev,
          vendor_id: data.vendor_id,
          ad_id: activeAd?.ad_id,
          user_id: data?.user_id,
          type: tabType,
          message: "",
          location: activeAd?.location,
          user_data: {
            _id: data?.userData._id,
            age: data?.userData?.age,
            city: {
              label: data?.userData?.city?.label,
              code: data?.userData?.city?.code,
            },
            gender: {
              label: data?.userData?.gender?.label,
              code: data?.userData?.gender?.code,
            },
            name: data?.userData?.name,
            state: {
              label: data?.userData?.state?.label,
              code: data?.userData?.state?.code,
            },
          },
        };
      });
      // getUserData()
    } else {
      // List the missing data steps here
      // console.log('Missing data:', {
      //     vendor_id: !data?.vendor_id,
      //     ad_id: !activeAd?.ad_id,
      //     user_id: !data?.user_id,
      //     type: !tabType,
      //     user_data: {
      //         _id: !data?.userData?._id,
      //         age: !data?.userData?.age,
      //         city: {
      //             label: !data?.userData?.city?.label,
      //             code: !data?.userData?.city?.code
      //         },
      //         gender: {
      //             label: !data?.userData?.gender?.label,
      //             code: !data?.userData?.gender?.code
      //         },
      //         name: !data?.userData?.name,
      //         state: {
      //             label: !data?.userData?.state?.label,
      //             code: !data?.userData?.state?.code
      //         }
      //     }
      // });
    }
  };

  useEffect(() => {
    const { vendor_id, ad_id, user_id, type, location, user_data } =
      accessUserContact;

    // Check if all required data is present
    const isDataComplete =
      vendor_id &&
      ad_id &&
      user_id &&
      type &&
      location &&
      user_data?._id &&
      user_data?.name &&
      user_data?.age &&
      user_data?.city?.label &&
      user_data?.city?.code &&
      user_data?.gender?.label &&
      user_data?.gender?.code &&
      user_data?.state?.label &&
      user_data?.state?.code;

    function hasData(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (typeof value === "object" && value !== null) {
            if (hasData(value)) return true;
          } else if (value !== "" && value !== null && value !== undefined) {
            console.log(`Data found at key: ${key} with value: ${value}`);
            return true;
          }
        }
      }
      return false;
    }

    if (hasData(accessUserContact)) {
      if (isDataComplete && !currentIsRedeemed) {
        getUserData();
      } else {
        viewContact();
      }
      setCurrentIsRedeemed(false);
    }

  }, [accessUserContact]);

  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handleCancel = () => {
    setLimitModal(false);
    setLeadPopup(false);
  };

  const getData = function (type, limit, page) {
    console.log("type", type);
    setLoading(true);
    dispatch(
      getSingleAdAnalytics({ type: type, adId: activeAd?.ad_id, limit, page })
    )
      .catch((error) => {
        console.log("Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (limitModal) {
      toast.warning(popupContent?.CONTACT_ACCESS?.LIMIT_REACHED?.content, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        className: "custom_toast",
      });
      setTimeout(() => {
        setLimitModal(false);
      }, 1000);
    }
  }, [limitModal]);

  useEffect(() => {
    console.log("analyticsData", analyticsData);
    console.log("singleAdAnalytics", singleAdAnalytics);
  }, [analyticsData, singleAdAnalytics]);

  useEffect(() => {
    console.log("singleAdAnalytics", singleAdAnalytics);
  }, [singleAdAnalytics]);

  useEffect(() => {
    return () => {
      isUnmounted.current = true;
      dispatch(resetSingleAd())
    };
  }, []);

  useEffect(() => {
    console.log("leadData", leadData);
  }, [leadData]);
  function formatDateTime(date) {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const padZero = (num) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = months[date.getMonth()]; // Get month name
    const day = padZero(date.getDate());

    let hours = date.getHours();
    const minutes = padZero(date.getMinutes());
    const period = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${month} ${day}, ${year}, ${padZero(hours)}:${minutes} ${period}`;
  }

  // Get the current date and time
  const currentDate = new Date();
  const formattedCurrentDate = formatDateTime(currentDate);



  return (
    <>
      {((loading || allAds.loading) && (bannerImage)) && (
        <div className="spinner center">
          <Spin />
        </div>
      )}
      {/* {
                warning?.verifiedStatus === 'rejected' && (
                    <RejectedUi className={warning?.statusClass} type={'dashboard'} title={warning?.title} description={warning?.content} />
                )
            } */}

      <section className="ads block ads_single_page">
        <Card style={{ marginBottom: "30px" }}>
          <Row className="ad_wrap">
            <Col xs={24} lg={11}>
              <div className="social_actions_wrap red_shadow">
                <figure style={{ marginBottom: "0" }} className="banner_ratio ">
                  {!bannerImage ? (
                    <div
                      className="poster_shimmer_wrap"
                      style={{ width: "100%" }}
                    >
                      <ShimmerCategoryItem
                        imageType="rectangular"
                        imageWidth="100%"
                        imageHeight="100%"
                        text={false}
                      />
                    </div>
                  ) : (
                    <img src={bannerImage} className="img_full cover" alt="" />
                  )}
                </figure>
                {activeAd?.call_to_action && (
                  <div
                    className="action_wrap mb-0"
                    style={{ background: activeAd?.call_to_action?.bg_color }}
                  >
                    <span className="icon">
                      <img src={activeAd?.call_to_action?.light_icon} alt="" />
                    </span>
                    <span className="sm">
                      {activeAd?.call_to_action?.title}
                    </span>
                  </div>
                )}
              </div>
              <div className="analytics_wrap">
                <div className="left_wrap" style={{ display: "flex" }}>
                  <div>
                    <span className="text_light">Status</span>&nbsp;
                    <span>
                      :{" "}
                      <span className="semibold text_light text_capitalize">
                        {getStatus(
                          activeAd?.status,
                          activeAd?.transaction_status
                        )}
                      </span>
                    </span>
                  </div>
                </div>
                <div className="right_wrap" style={{ display: "flex" }}>
                  <div>
                    <span className="text_light">Contact Accessed</span>&nbsp;
                    {activeAd?.numberOfLeadsLeft && (
                      <span>
                        :{" "}
                        <span className="semibold text_red">
                          {activeAd?.numberOfLeadsUsed}/
                          {activeAd?.numberOfLeadsLeft}
                        </span>
                      </span>
                    )}
                    {/* {
                                            (activeAd?.numberOfLeadsUsed && activeAd?.numberOfLeadsLeft) && (
                                                <span>
                                                    : <span className="semibold text_red">{activeAd?.numberOfLeadsUsed}/{activeAd?.numberOfLeadsLeft}</span>
                                                </span>
                                            )
                                        } */}
                  </div>
                </div>
              </div>
            </Col>
            <Col className="ad_info" xs={24} lg={13}>
              {formattedStartDate && (
                <div>
                  <span className="text_light">Start Date</span>&nbsp;
                  <span>: {formattedStartDate}</span>
                </div>
              )}
              {formattedEndDate && (
                <div>
                  <span className="text_light">End Date</span>&nbsp;
                  <span>: {formattedEndDate}</span>
                </div>
              )}

              <div>
                <span className="text_light">Plan</span>&nbsp;
                {activeAd?.plan && (
                  <span>: {activeAd?.plan} ({activeAd?.price})</span>
                )}
              </div>
              <div>
                <span className="text_light">Target Reach</span>&nbsp;
                {
                  activeAd?.target_reach && (
                    <span>: {activeAd?.target_reach}</span>
                  )
                }
              </div>
              <div>
                <span className="text_light">Reach Progress</span>&nbsp;
                {activeAd?.reach_progress && <span>: {activeAd?.reach_progress}%</span>}
              </div>
              <div>
                <span className="text_light">Location</span>&nbsp;
                {activeAd?.location && (
                  <span>: {activeAd?.location}</span>
                )}
              </div>
              {bannerImage && (
                <Button
                  type="primary"
                  className="wide"
                  style={{ width: "100%", marginTop: ".7em" }}
                  onClick={handleDuplicate}
                >
                  Duplicate
                </Button>
              )}
            </Col>
          </Row>
        </Card>
        <Card className="recentCard analytics_table">
          {(!analyticsData || !bannerImage) && (
            <div className="table_shimmer_parent">
              <TableShimmer columns={5} rows={10} />
            </div>
          )}

          <Tabs
            onChange={tabsHandle}
            className="custom_tab"
            defaultActiveKey="1"
            items={[

              {
                label: `Clicks ${count?.click ? ` (${count.click})` : ""}`,
                key: "click",
                children: (
                  <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    <Table
                      style={{ color: customStyles.colorTextLight }}
                      className="custom_table"
                      columns={analytics?.length > 0 ? viewsColumns : null}
                      dataSource={
                        analytics?.map((item, index) => ({
                          ...item,
                          key: index,
                        })) || []
                      }
                      pagination={
                        totalCount > 10
                          ? {
                            pageSize: 10,
                            total: totalCount,
                            onChange: (page) => getData(tabType, 10, page),
                          }
                          : false
                      }
                    />
                  </div>
                ),
              },
              {
                label: `Contacts Accessed${count?.user_contacts_accessed ? ` (${count.user_contacts_accessed})` : ""}`,
                key: "accessContact",
                children: (
                  <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    <Table
                      style={{ color: customStyles.colorTextLight }}
                      className="custom_table"
                      columns={
                        analytics?.length > 0 ? contactAccessedColumn : null
                      }
                      dataSource={
                        analytics?.map((item, index) => ({
                          ...item,
                          key: index,
                        })) || []
                      }
                      pagination={
                        totalCount > 10
                          ? {
                            pageSize: 10,
                            total: totalCount,
                            onChange: (page) => getData(tabType, 10, page),
                          }
                          : false
                      }
                    />
                  </div>
                ),
              },
              {
                label: `Enquiries${count?.enquiry ? ` (${count.enquiry})` : ""}`,
                key: "enquiry",
                children: (
                  <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    <Table
                      style={{ color: customStyles.colorTextLight }}
                      className="custom_table"
                      columns={analytics?.length > 0 ? enquiryColumns : null}
                      dataSource={
                        analytics?.map((item, index) => ({
                          ...item,
                          key: index,
                        })) || []
                      }
                      pagination={
                        totalCount > 10
                          ? {
                            pageSize: 10,
                            total: totalCount,
                            onChange: (page) => getData(tabType, 10, page),
                          }
                          : false
                      }
                    />
                  </div>
                ),
              },
            ]}
          />
        </Card>
      </section>
      {/* {
                limitModal && 
                 toast.warning(popupContent?.CONTACT_ACCESS?.LIMIT_REACHED?.content, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                    className: 'custom_toast'
                })
            } */}
      {/* <Modal afterClose={() => (document.body.style.overflow = 'initial')} className='sm_modal limit_reached_modal  close_btn_removed' style={{ textAlign: 'center' }} open={limitModal} footer={[
                <div style={{ textAlign: 'center' }} >
                    <Button key="submit" type="primary" className='short sm' onClick={handleCancel} >
                        Ok
                    </Button>
                </div>
            ]} onCancel={handleCancel}>
                <span className='cnt'>
                    You have reached your contact access limit.
                </span>
            </Modal> */}
      {/* onClick={handleOk} */}

      <Modal className='sm_modal lead_details_modal  close_btn_removed center_modal' style={{ textAlign: 'center' }} open={leadPopup} footer={[
        <div style={{ textAlign: 'center' }} >
          <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
            Close
          </Button>
        </div>
      ]} onCancel={handleCancel}>
        {leadData?.number ? (
          <div>
            <h2 className="text-center text_red text_lg">Lead Details</h2>
            <ul>
              <li>
                <span className="text_sm">Name </span>
                <span className="text_sm">{leadData?.name}</span>
              </li>
              {/* <li>
                 <span>Ad Views</span>
                 <span>145</span>
               </li>
               <li>
                 <span>Ad Clicks</span>
                 <span>5</span>
               </li> */}
            </ul>
            <ul>
              <li>
                <span className="text_sm">Contact Number</span>
                <span className="text_sm">{leadData?.number}</span>
              </li>
              <li>
                <span className="text_sm">Location</span>
                <span className="text_sm">{leadData.location}</span>
              </li>
            </ul>
            <span className="date text-center sm2">
              Contact Accessed on {leadData.accessedDate ? DateService.formatDateCustom(leadData.accessedDate, true) : formattedCurrentDate}
            </span>
          </div>
        ) : (
          <h2 className="text_lg text_red">No data available due to an API error. Please contact support</h2>
        )}

      </Modal>
    </>
  );
};

export default AdsSinglePage;

